import { AxiosError } from "axios";
import { UseComboboxState } from "downshift";
import { useQuery } from "react-query";
import {
  ApiGetResponse,
  debouncedSearch,
  generateTemporaryToken,
  SearchAddress,
} from "../api/addressApi";
import { CountryCode } from "../types";

interface Props {
  countryCode: CountryCode;
}

export const useAddressSearch = ({ countryCode }: Props) => {
  const { data } = useQuery<ApiGetResponse, AxiosError>(countryCode, () =>
    generateTemporaryToken(countryCode),
  );

  const tempToken = data?.key;

  const search = async ({
    inputValue,
  }: Partial<UseComboboxState<SearchAddress>>): Promise<SearchAddress[]> => {
    if (!inputValue) {
      return [];
    }

    try {
      const res = await debouncedSearch({
        addressLineQuery: inputValue,
        countryCode,
        tempToken,
      });

      if (!res || "error" in res) {
        return [];
      }

      return res.data;
    } catch (err) {
      return [];
    }
  };

  return { search };
};
